export const CashFlowCategorizationEnum: {
    CATEGORIZATION_CASH: CashFlowCategorizationType,
    CATEGORIZATION_CASH_REFINED: CashFlowCategorizationType,
    REFINEMENT: CashFlowCategorizationType
} = {
    CATEGORIZATION_CASH: 'cashOnly',
    CATEGORIZATION_CASH_REFINED: 'cashEnhanced',
    REFINEMENT: 'enhancementOnly',
};
